import { useEffect } from 'react';
import SignInFormv1 from '../../components/SignInFormv1/SignInForm';

const SignInPage = (props) => {
  useEffect(() => {
    document.title = props.formType == 'signup' ? 'Sign Up' : 'Sign In';
  }, []);

  return (
    <>
      <div className="flex w-full h-full">
        <SignInFormv1 {...props} />
      </div>
    </>
); };

export default SignInPage;
